import { useMutation } from "react-query";
import api from "../../client";
import { Institution } from "../../types/institution";

const postData = async (id: string | undefined): Promise<Institution> => {
  const { data } = await api.post(`/institutions/${id}/approve`, {});

  return data;
};

export const useApproveInstitution = () => {
  return useMutation((id: string | undefined) => {
    return postData(id);
  });
};
